import { IconSVGProps } from '../types'

export const ReorderIcon = ({ className, fill }: IconSVGProps) => (
  <svg
    className={className}
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill={fill}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M11.334 2.66668V1.37868C11.3339 1.31528 11.3519 1.25317 11.3858 1.19963C11.4198 1.14609 11.4683 1.10334 11.5257 1.0764C11.583 1.04946 11.6469 1.03944 11.7098 1.04752C11.7727 1.0556 11.8319 1.08144 11.8807 1.12201L14.6273 3.41068C14.68 3.45457 14.7178 3.51362 14.7356 3.57979C14.7535 3.64596 14.7505 3.71603 14.7272 3.78045C14.7038 3.84487 14.6611 3.90051 14.6049 3.9398C14.5488 3.97909 14.4819 4.00012 14.4133 4.00001H1.33398V2.66668H11.334ZM1.33398 12H14.6673V13.3333H1.33398V12ZM1.33398 7.33334H14.6673V8.66668H1.33398V7.33334Z" />
  </svg>
)
